<template>
<div class="page page_video">
    <van-list v-model="loading" :finished="finished"  :immediate-check="false" finished-text="没有更多了" @load="getData">
        <div class="list clearfix">
            <div class="item f-l" v-for="video in dataList" :key="video.id" @click="goVideoDetail(video.video)">
                <div class="tu">
                    <img :src="imageUrl+video.video.thumb" alt="" class="">
                </div>
                <div class="text">
                    <div class="title slh_s">{{ video.video.title }}</div>
                    <div class="time">{{ video.created_at }}</div>
                </div>
                <!-- 没有这个,可能以后会有 -->
                <!-- <div class="tag bg_red">{{ video.type }}</div> -->
            </div>
        </div>
    </van-list>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
			dataList: [],
            loading: true,
            token: null,
			finished: false,
			pages: {
				page: 1,
				size: 10
			}
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我的视频'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log('sdjy://member/memberInfo')
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                this.getData()
                responseCallback({})
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            this.getData();
        }
        // // 获取列表
		// this.getData();
    },
    methods: {
        // 获取列表
        getData() {
            if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var params = {
				token: this.token,
				page: this.pages.page,
				size: this.pages.size
            }
            this.$api.living.myVideo(params).then(res => {
                if (res.code == 200) {
					console.log(res)
					var list = []
					list = res.result
					if(list.length != 0){
						for(var i in list){
							this.dataList.push(list[i])
						}
						this.pages.page++
						this.loading = false
					}else{
						this.finished = true
					}  
                }else{
					this.finished = true
				}
            })
        },
		// 播放视频 -- 弃用,先去详情页再进播放页
		goPlayVideo(id){
			var that = this
			that.$router.push({
				path: '/video/play',
				query: {
					id: id
				}
			});
		},
		// 视频详情
		goVideoDetail(item) {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': that.$publicData.clientUrl + '/video/detail?id=' + item.id + '&is_charge='+ item.is_charge + '&prices=' + item.prices
                    }
                }
                that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                that.$router.push({
                    path: `/video/detail`,
                    query: {
						id: item.id,
						is_charge: item.is_charge,
						prices: item.prices
                    }
                })
            }            
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
